"use strict";

const SEARCH_SELECTOR = "[data-faq-search]";
const INPUT_SELECTOR = "[data-faq-search-input]";
const RESULTS_SELECTOR = "[data-faq-results]";
const EMPTY_SELECTOR = "[data-faq-empty]";
const AJAX_ACTION = "faq_search_action";
const DEBOUNCE_MS = 300;

function debounce(fn, delay) {
    let timer = null;

    return function (...args) {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => fn.apply(this, args), delay);
    };
}

async function fetchFaqs(search) {
    const data = new FormData();
    data.append("action", AJAX_ACTION);
    data.append("nonce", window.WPURLS.nonce);
    data.append("search", search);

    const response = await fetch(window.WPURLS.ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        body: data,
    });

    const payload = await response.json();

    return payload && payload.success ? payload.data : null;
}

function initFaqSearch() {
    const searchWrap = document.querySelector(SEARCH_SELECTOR);
    const input = document.querySelector(INPUT_SELECTOR);
    const results = document.querySelector(RESULTS_SELECTOR);
    const emptyState = document.querySelector(EMPTY_SELECTOR);

    if (!searchWrap || !input || !results || !window.WPURLS) {
        return;
    }

    async function updateResults() {
        const query = input.value.trim();

        results.setAttribute("aria-busy", "true");

        try {
            const payload = await fetchFaqs(query);

            if (payload === null) {
                return;
            }

            results.innerHTML = payload.html || "";

            if (emptyState) {
                if (payload.count > 0) {
                    emptyState.setAttribute("hidden", "");
                } else {
                    emptyState.removeAttribute("hidden");
                }
            }
        } finally {
            results.setAttribute("aria-busy", "false");
        }
    }

    const debouncedUpdate = debounce(updateResults, DEBOUNCE_MS);

    input.addEventListener("input", debouncedUpdate);

    input.addEventListener("search", function () {
        updateResults();
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFaqSearch, { once: true });
} else {
    initFaqSearch();
}
